export default "__VITE_ASSET__CoExz2Kh__"